import { Injectable, signal, TemplateRef } from '@angular/core';
import { TreeNode, TreeNodeEvent } from '@libs/front/components/tree-view/tree-view.component';

export interface NavLeftConfig {
  treeData:          TreeNode[];
  searchText?:       string;
  selectedNodeId?:   string | null;
  labelEllipsis?:    'start' | 'end';   // position des « ... » sur les noms (défaut : 'end')
  // ── Templates layout nav-left ─────────────────────────────────────────────
  headerTemplate?:   TemplateRef<any> | null;   // bouton retour
  searchTemplate?:   TemplateRef<any> | null;   // search + actions toolbar
  siteCardTemplate?: TemplateRef<any> | null;   // card verte nom du site
  settingsTemplate?: TemplateRef<any> | null;   // onglet Settings (grouping)
  actionsTemplate?:  TemplateRef<any> | null;   // boutons extra (mode area)
  // ── Callbacks ─────────────────────────────────────────────────────────────
  onNodeClick?:      (event: TreeNodeEvent) => void;
  onBadgeClick?:     (event: TreeNodeEvent) => void;
  onCheckboxChange?: (event: TreeNodeEvent) => void;
}

@Injectable({ providedIn: 'root' })
export class NavLeftService {

  private _config = signal<NavLeftConfig>({ treeData: [] });
  private _mobileNavVisible = signal(true);

  readonly config           = this._config.asReadonly();
  readonly mobileNavVisible = this._mobileNavVisible.asReadonly();

  showMobileNav(): void { this._mobileNavVisible.set(true); }
  hideMobileNav(): void { this._mobileNavVisible.set(false); }

  set(config: NavLeftConfig): void {
    this._config.set(config);
  }

  setTreeData(treeData: TreeNode[]): void {
    this._config.update(c => ({ ...c, treeData }));
  }

  setSearchText(searchText: string): void {
    this._config.update(c => ({ ...c, searchText }));
  }

  setSelectedNodeId(id: string): void {
    this._config.update(c => ({ ...c, selectedNodeId: id }));
  }

  reset(): void {
    this._config.set({ treeData: [] });
  }
}